import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { silentRequest } from "authConfig";
import axios from "axios";
import { redirectToLoginFromAuthFailure } from "features/Authentication/authRecovery";
import { msalInstance } from "msalInstance";
import { GetUrl } from "../helpers/get-url";

const ax = axios.create();
ax.defaults.baseURL = GetUrl();

ax.interceptors.request.use(async (config) => {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    redirectToLoginFromAuthFailure({
      instance: msalInstance,
    });
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...silentRequest,
      account: account,
    });

    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${response.accessToken}`,
    };
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      redirectToLoginFromAuthFailure({
        instance: msalInstance,
      });
    }

    throw error;
  }
  return config;
});

export default ax;
